import { Role } from '~/common/providers/auth/role';

export const analyticsMenuAllowedRoles: Role[] = [
  'LOGLASS_SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'CORP_PLANNING',
];

export const analyticsMenuViewAccountAllowedRoles: Role[] = ['GENERAL', 'MANAGER'];
